import { api } from '../../core/trpc'
import { useWebContent } from '../../hooks/useWebContent'
import { richTextListClassName } from '../../utils/richText'
import { ProgramCard } from './ProgramCard'

const tierColors = [
    { bg: 'bg-amber-400', ring: 'ring-amber-200' },
    { bg: 'bg-slate-400', ring: 'ring-slate-200' },
    { bg: 'bg-purple-300', ring: 'ring-purple-100' },
    { bg: 'bg-emerald-400', ring: 'ring-emerald-200' },
    { bg: 'bg-rose-400', ring: 'ring-rose-200' },
]

export const LifestyleProgramsSection = ({
    contentKey = 'LIFESTYLE_PROGRAMS',
}: {
    contentKey?: string
}) => {
    const [programs] = api.lifestyleProgram.getPublicList.useSuspenseQuery()
    const { getText } = useWebContent(contentKey)

    return (
        <section id="lifestyle-programs" className="mx-auto w-full max-w-[1280px] px-6 py-24">
            <div className="mb-16 text-center">
                <h2 className="mb-4 text-3xl font-bold text-brand-dark md:text-4xl">
                    {getText('heading')}
                </h2>
                <div
                    dangerouslySetInnerHTML={{ __html: getText('subheading') }}
                    className={`mx-auto max-w-2xl text-brand-gray ${richTextListClassName}`}
                />
            </div>

            {programs.length > 0 ? (
                <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                    {programs.map((program, idx) => (
                        <ProgramCard
                            key={program.id}
                            name={program.name}
                            price={program.price}
                            originalPrice={program.originalPrice}
                            descriptionHtml={program.description ?? ''}
                            cmsBlocks={program.cmsBlocks}
                            colorBg={tierColors[idx % tierColors.length].bg}
                            colorRing={tierColors[idx % tierColors.length].ring}
                            checkoutHref={`/checkout?programId=${program.id}`}
                            detailsHref={`/lifestyle-programs/${program.id}`}
                        />
                    ))}
                </div>
            ) : (
                <div className="py-16 text-center">
                    <p className="text-lg text-brand-gray">{getText('emptyState')}</p>
                </div>
            )}
        </section>
    )
}
